export default {
	cartTabMenu: {
		label: "Cart",
		emptyButton: "Empty",
		emptyButtonTooltip: "Removes all items from the cart.",
	},
	cartTabMenuItem: {
		removeTooltip: "Removes the item from the cart.",
	},
	cartPosition: {
		showParts: "Show parts",
	},
	cartPositionItem: {
		materialLabel: "Material:",
		articleIdLabel: "Blexon number:",
		certificateLabel: "Certificate:",
		revalidateButton: "Blexonise",
		quantityUnit: "{quantity} pcs.",
		quantityPlaceholder: "pcs.",
		removeTooltip:
			"Removes the item from the cart. Does not remove the item from parts lists.",
		addToSavedCartTooltip: "Add position to the current parts list",
		loadError: "The item could not be loaded.",
	},
	currentCart: {
		title: "Cart",
		emptyButton: "Empty",
		emptyButtonTooltip: "Removes all items from the cart.",
		createListButton: "Create parts list",
		createListButtonTooltip: "Create a parts list from the cart.",
		emptyCartText: "The cart is empty. Go to {link} to add new items to the cart.",
		emptyCartLinkText: "'Items'",
		newCartDialog: {
			title: "New parts list",
			text: "The cart will be saved as a parts list under the following name:",
			nameLabel: "Name of the new parts list",
			saveButtonTooltip: "Saves the cart as a parts list.",
		},
		nameExistsError: "A parts list with this name already exists.",
		messages: {
			cartSaved: "Parts list was saved.",
		},
	},
	savedCarts: {
		title: "Parts lists",
		noCartsText:
			"No parts lists saved yet. Add items to the cart in order to create a new parts list from the cart.",
		selectPlaceholder: "Select list...",
		itemTooltipQuantity: "Quantity: {quantity}",
		deleteButton: "Delete",
		deleteButtonTooltip: "Delete parts list.",
		quantityLabel: "Quantity",
		quantityPlaceholder: "pcs.",
		addButtonTooltip:
			"Adds all items of the parts list to the cart. For items already present, the quantity is increased.",
		addButtonMultiple: "Add {amount} x to cart",
		addButtonSingle: "Add to cart",
		removeArticleTooltip: "Remove from parts list",
		addArticleTooltip: "Add to cart",
		deleteDialog: {
			title: "Delete parts list",
			text: "Are you sure you want to delete this parts list?",
			text2: "The items contained in the list will not be deleted.",
			confirmButton: "Delete",
			confirmButtonTooltip: "Permanently deletes the parts list.",
		},
		messages: {
			articlesAdded: "Items from the parts list have been added to the cart.",
			articleAdded:
				"{quantity} pcs. added to cart. {oldQuantity} + {quantity} = {newQuantity}",
			articleRemoved: "The item has been removed from the parts list.",
			cartDeleted: "The parts list has been deleted.",
		},
	},
};
